import { render, staticRenderFns } from "./convenio.vue?vue&type=template&id=200b5224"
import script from "./convenio.vue?vue&type=script&lang=js"
export * from "./convenio.vue?vue&type=script&lang=js"
import style0 from "./convenio.vue?vue&type=style&index=0&id=200b5224&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports